import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface TextFilterField {
    key: string;
    label: string;
    placeholder?: string;
    value: string;
}

@Component({
    selector: 'text-filter-bar',
    templateUrl: './text-filter-bar.component.html',
    styleUrls: ['./text-filter-bar.component.less'],
    standalone: false
})
export class TextFilterBarComponent {
    @Input() fields: TextFilterField[] = [];
    @Output() fieldsChange = new EventEmitter<TextFilterField[]>();
    @Output() filterChange = new EventEmitter<{ [key: string]: string }>();

    onFieldChange(field: TextFilterField, value: string) {
        field.value = value;
        this.emitChanges();
    }

    clearFilters() {
        this.fields.forEach(field => field.value = '');
        this.emitChanges();
    }

    private emitChanges() {
        this.fieldsChange.emit(this.fields);
        const values: { [key: string]: string } = {};
        this.fields.forEach(field => values[field.key] = field.value);
        this.filterChange.emit(values);
    }
}
